<div *ngIf="status =='Submitted' || status =='Approved'; else studentform">
    <app-viewstudentprofile></app-viewstudentprofile>
</div>
<ng-template #studentform>
    <app-studentprofile></app-studentprofile>
</ng-template>